import React, { useState, useEffect } from "react";
import {
  Box,
  CircularProgress,
  ClickAwayListener,
  Divider,
  Fab,
  FormControl,
  Grid,
  Grow,
  IconButton,
  InputLabel,
  MenuItem,
  Paper,
  Popper,
  Select,
  TextField,
  Typography,
} from "@mui/material";
import { Close } from "@mui/icons-material";
import { makeStyles } from "@mui/styles";
import CommonSlider from "./CommonSlider";
import moment from "moment";
import "react-date-range/dist/styles.css";
import "react-date-range/dist/theme/default.css";
import { DateRange } from "react-date-range";
import {
  checkIshaUSAccess,
  checkIshaAccess,
  dateFormat,
  displaySlots,
} from "../constants/Calendar-constants";
import {
  blockMultipleRooms,
  getRoomBlockErrorMessage,
} from "../../InventoryCalendar/api/InventoryApi";
import { shallowEqual, useSelector } from "react-redux";
import { toast } from "material-react-toastify";
import { handleSpringDataRequest } from "../../../api";

const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
    flexWrap: "wrap",
  },
  textField: {
    padding: theme.spacing(2),
  },
  custom_box: {
    width: "100%",
    padding: theme.spacing(2),
    whiteSpace: "no-wrap",
    borderRadius: 10,
  },
}));

const BlockView = (props) => {
  const { hotel } = useSelector(
    ({ auth }) => ({
      hotel: auth.selectedHotel,
    }),
    shallowEqual
  );
  const {
    open,
    eventData,
    closeFunc,
    reload,
    modalClose,
    reloadagain,
    viewType,
    showBlockRoomError,
    isSingleSlot,
  } = props;
  const classes = useStyles();
  const [anchorEl, setAnchorEl] = useState(null);
  const [loading, setLoading] = useState(false);
  const [blockType, setblockType] = useState("MANUAL");

  const [currentDateSelection, setCurrentDateSelection] = useState(() => {
    const startDate = new Date(eventData.start);
    let endDate = new Date(eventData.end);

    if (
      viewType !== "resourceTimelineDay" &&
      viewType === "resourceTimelineWeek" &&
      hotel.slotType !== "NOON" &&
      displaySlots[eventData.end.getHours()] !== 0
    ) {
      endDate = new Date(eventData.end);
    } else {
      endDate = new Date(eventData.end);
    }

    // Extract only year, month, and day for proper date comparison
    const startDay = new Date(
      startDate.getFullYear(),
      startDate.getMonth(),
      startDate.getDate()
    );
    const endDay = new Date(
      endDate.getFullYear(),
      endDate.getMonth(),
      endDate.getDate()
    );

    // Calculate full days difference
    const dayDiff = Math.ceil((endDay - startDay) / (1000 * 60 * 60 * 24));
    console.log("dayDiff", dayDiff);

    // Reduce endDate by one day only if the difference is >= 1
    if (isSingleSlot && dayDiff >= 1) {
      endDate.setDate(endDate.getDate() - 1);
    }

    return [{ startDate, endDate }];
  });
  const [showDatePicker, setShowDatePicker] = useState(false);
  const [reason, setReason] = useState("");

  const unblock = async () => {
    try {
      setLoading(true);
      const payload = {
        startDate: moment(currentDateSelection[0].startDate).format(dateFormat),
        endDate: moment(currentDateSelection[0].endDate).format(dateFormat),
        physicalRoomIds: [eventData.resource.id],
        reason: reason,
      };
      await blockMultipleRooms([payload]).then(() => {
        toast.success("Successfully blocked");
      });
      reload();
      if (sessionStorage.getItem("types") === "month") {
        reloadagain();
        reloadagain();
      }

      closeFunc();
    } catch (e) {
      toast.error(
        getRoomBlockErrorMessage(
          e,
          "Selected rooms could not be blocked. Please try again."
        )
      );
      console.log(e);
      closeFunc();
    }
  };

  const getDateText = () => {
    let val = "";
    val =
      val +
      moment(currentDateSelection[0].startDate).format("DD MMM YYYY") +
      " - ";
    val = val + moment(currentDateSelection[0].endDate).format("DD MMM YYYY");
    return val;
  };
  const [blockRoomCodeData, setblockRoomCodeData] = useState([]);
  useEffect(() => {
    getAllData();
  }, []);

  const getAllData = () => {
    handleSpringDataRequest(`core/api/v1/block-room-reason/get`)
      .then((res) => setblockRoomCodeData(res.map((item) => item.block_reason)))
      .catch((err) => console.error("Error in fetching the data"));
  };

  return (
    <div className={classes.root}>
      <CommonSlider
        onBackdropClick={closeFunc}
        onClose={modalClose}
        open={open}
      >
        <Grid container className={classes.textField}>
          <Grid item xs={10} alignSelf="center">
            <Typography variant="h5">Block rooms</Typography>
          </Grid>
          <Grid item xs={2}>
            <IconButton
              onClick={() => {
                modalClose();
              }}
              sx={{ float: "right" }}
            >
              <Close />
            </IconButton>
          </Grid>
        </Grid>

        <Grid container spacing={2} className={classes.textField}>
          <Grid item xs={12}>
            <Box className={classes.custom_box} bgcolor="primary.main">
              <Typography>
                {`You are currently blocking room number : ${eventData.resource.id}`}
              </Typography>
            </Box>
          </Grid>
          <Grid item xs={12}>
            <div>
              <ClickAwayListener
                onClickAway={() => {
                  setShowDatePicker(false);
                  setAnchorEl(null);
                }}
              >
                <div>
                  <TextField
                    fullWidth
                    focused={showDatePicker}
                    id="currentDateSelection"
                    name="currentDateSelection"
                    InputProps={{ readOnly: true }}
                    value={getDateText()}
                    label="Date range"
                    onClick={(eve) => {
                      setAnchorEl(eve.currentTarget);
                      setShowDatePicker(true);
                    }}
                  ></TextField>
                  {showDatePicker && (
                    <Popper
                      style={{ zIndex: 2 }}
                      open={showDatePicker}
                      anchorEl={anchorEl}
                      placement="bottom"
                      transition
                      disablePortal
                    >
                      {({ TransitionProps, placement }) => (
                        <Grow
                          style={{
                            transformOrigin: (placement = "bottom-end"),
                          }}
                          {...TransitionProps}
                        >
                          <Paper
                            elevation={5}
                            className="inventory-daterange-custom"
                          >
                            <DateRange
                              color="#1BC5BD"
                              rangeColors={["#1BC5BD"]}
                              editableDateInputs={false}
                              moveRangeOnFirstSelection={false}
                              onChange={(data) => {
                                setCurrentDateSelection([{ ...data.range1 }]);
                              }}
                              ranges={currentDateSelection}
                              minDate={new Date()}
                            ></DateRange>
                          </Paper>
                        </Grow>
                      )}
                    </Popper>
                  )}
                </div>
              </ClickAwayListener>
            </div>
          </Grid>
          <Grid item xs={12}>
            {checkIshaAccess(hotel?.emailId) && (
              <TextField
                value={reason}
                label="Reason"
                fullWidth
                multiline
                rows={3}
                onChange={(eve) => {
                  setReason(eve.target.value);
                }}
              ></TextField>
            )}

            {checkIshaUSAccess(hotel?.emailId) && (
              <div>
                <FormControl fullWidth>
                  <InputLabel id="demo-simple-select-label">Type</InputLabel>
                  <Select
                    labelId="demo-simple-select-label"
                    id="demo-simple-select"
                    onChange={(e) => setblockType(e.target.value)}
                    className="mr-4"
                    label="Type"
                    value={blockType}
                  >
                    <MenuItem value={"MANUAL"}>{"MANUAL"}</MenuItem>
                    <MenuItem value={"PREDEFINED"}>{"PREDEFINED"}</MenuItem>
                  </Select>
                </FormControl>

                {blockType === "MANUAL" && (
                  <TextField
                    value={reason}
                    label="Reason"
                    fullWidth
                    multiline
                    style={{ marginTop: "1rem" }}
                    rows={3}
                    onChange={(eve) => {
                      setReason(eve.target.value);
                    }}
                  ></TextField>
                )}
                {blockType === "PREDEFINED" && (
                  <FormControl fullWidth style={{ marginTop: "1rem" }}>
                    <InputLabel id="demo-simple-select-label">
                      Block reason
                    </InputLabel>
                    <Select
                      labelId="demo-simple-select-label"
                      id="demo-simple-select"
                      onChange={(e) => setReason(e.target.value)}
                      className="mr-4"
                      label="Block reason"
                      value={reason}
                    >
                      <MenuItem value={""}>{"-"}</MenuItem>
                      {blockRoomCodeData?.map((item) => (
                        <MenuItem value={item}>{item}</MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                )}
              </div>
            )}

            {showBlockRoomError && (
              <Box
                className={classes.custom_box}
                bgcolor="#FFF4E5"
                style={{ marginTop: "1rem" }}
              >
                <Typography>
                  {`There are unassigned reservations which needs to be assigned, Do
                you still want to block the rooms ?`}
                </Typography>
              </Box>
            )}
          </Grid>
        </Grid>

        <Grid container>
          <Grid item xs={12}>
            <Divider />
          </Grid>
          <Grid
            item
            xs={12}
            container
            justifyContent="flex-end"
            className={classes.textField}
          >
            <Fab
              disabled={loading}
              type="button"
              color="primary"
              onClick={unblock}
              variant="extended"
            >
              Block room
              {loading && (
                <CircularProgress size={15} color="inherit" sx={{ ml: 1.5 }} />
              )}
            </Fab>
          </Grid>
        </Grid>
      </CommonSlider>
    </div>
  );
};

export default BlockView;
